import { Injectable } from '@angular/core';
import { Profile } from '../models/profile';
import { environment } from '../../../../environments/environment';
import { User } from '../models/user';
import { SessionService } from './session.service';
import { Endpoints } from '../../../models/endpoints';
import { HttpService } from '../../shared/services/http.service';
import { LogService } from '../../shared/services/log.service';

/**
 * A service to connect a user from its profile.
 */
@Injectable({
  providedIn: 'root'
})
export class SessionConnectorService {

  constructor(private session: SessionService, private http: HttpService) { }

  private LOG: LogService = new LogService(SessionConnectorService);

  public connect(profile: Profile) {
    if (environment.facturation === 'false') {
      // Do not load the structure name
      let user: User = profile.user;
      user.raisonSociale = 'raison sociale temporaire';
      this.session.connect(profile);
    } else {
      // Retrieve the structure name before connecting the user
      this.http.get(Endpoints.STRUCTURE + '?siret=' + profile.user.siret)
        .subscribe(
          (structure: any) => {
            // Updating the user in the profile isn't great...
            let user: User = profile.user;
            if (structure) {
              user.raisonSociale = structure.raisonSociale;
            }
            user.siret = profile.user.siret;
            user.service = profile.user.service;
            this.session.connect(profile);
          },
          error => {
            this.LOG.error(error);
          }
        );
    }
  }
}
